/**
 * @Author: zpc
 * @Description:
 * @DateTime: Created in 2021-12-15 16:59:00
 */

 import EnumItem, {enumMixn} from "./enumItem";

 /**
  * UPS状态
  */
 let EnumInvertState  = {
     "正常"             : new EnumItem('正常', "0"),
     "故障"              : new EnumItem('故障', "1"),
     ...enumMixn
 }
 export default EnumInvertState 